import React from 'react';
import PropTypes from 'prop-types';
import { Spacer, Visible } from '@tfecom-thermofisher/react-komodo-design';

import {
  NORMALIZATION,
  VOLUME,
  CONCENTRATION,
  VOLUME_UNIT,
  CONCENTRATION_UNIT,
  NORMALIZATION_OPTIONS,
} from 'src/constants/forms';
import { SectionTitle, DataSelector } from 'src/components';

import { DropdownWithInput } from './components';
import { normalizationSelectors } from './config';
import messages from './messages';
import './Normalization.style.scss';

const MORE_NORMALIZATION_INFO_LINK =
  'https://www.thermofisher.com/us/en/home/products-and-services/product-types/primers-oligos-nucleotides/invitrogen-custom-dna-oligos/popups/normalization.html?CID=fl-configoligonormalization';

const NormalizationComponent = ({
  formData,
  onChangeData,
  plateSizeDetails,
}) => {
  const selectedNormalization = formData[NORMALIZATION]?.value;
  const showVolume =
    selectedNormalization === NORMALIZATION_OPTIONS.VOLUME ||
    selectedNormalization === NORMALIZATION_OPTIONS.CONCENTRATION_VOLUME;
  const showConcentration =
    selectedNormalization === NORMALIZATION_OPTIONS.CONCENTRATION ||
    selectedNormalization === NORMALIZATION_OPTIONS.CONCENTRATION_VOLUME;

  return (
    <div>
      <SectionTitle title={messages.normalization} allFieldsRequired />
      <Spacer bottom="22" />

      <DataSelector
        {...{
          title: messages.normalization,
          config: normalizationSelectors,
          selectedValue: selectedNormalization,
          onSelect: (value) => onChangeData(value, NORMALIZATION, true),
          moreInfoLink: MORE_NORMALIZATION_INFO_LINK,
        }}
      />
      <Spacer top="32" />

      <Visible when={showVolume}>
        <DropdownWithInput
          {...{
            formData,
            onChangeData,
            fieldName: VOLUME,
            dropdownName: VOLUME_UNIT,
            plateSizeDetails,
          }}
        />
      </Visible>

      <Visible when={showConcentration}>
        <DropdownWithInput
          {...{
            formData,
            onChangeData,
            fieldName: CONCENTRATION,
            dropdownName: CONCENTRATION_UNIT,
            plateSizeDetails,
          }}
        />
      </Visible>
    </div>
  );
};

NormalizationComponent.propTypes = {
  formData: PropTypes.object,
  onChangeData: PropTypes.func.isRequired,
  plateSizeDetails: PropTypes.object,
};

export default NormalizationComponent;
